export default __webpack_public_path__ + "media/images/backgrounds/bg-7-77b1424c92b960705171d77acb9b1424.jpg";